import { AssignedEquipmentModel } from "./../../../../models/equipmentsModel";
import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import { State } from "../../../../core/store";
import { BaseComponent } from "src/app/core/abstracts/baseComponent";
import { getEquipmentAssignPdf, getMyEquipmentList } from "src/app/core/store/equipment/equipment.actions";

@Component({
    selector: "app-list-my-equipment",
    templateUrl: "./list-my-equipment.component.html",
    styleUrls: ["./list-my-equipment.component.scss"],
    standalone: false
})
export class ListMyEquipmentComponent extends BaseComponent implements OnInit {
  equipments: AssignedEquipmentModel[];
  loadingMyEquipments = false;

  constructor(
    private store: Store<State>,
    private router: Router,
  ) {
    super();
  }

  ngOnInit() {
    this.subs.push(
      this.store
        .select((s) => s.accountState.user)
        .subscribe((user) => {
          if (user && user.id) {
            this.store.dispatch(getMyEquipmentList());
          }
        }),
      this.store
        .select((s) => s.equipmentState.myEquipments)
        .subscribe((myEquipments) => {
          this.equipments = myEquipments;
        }),
      this.store
        .select((s) => s.equipmentState.loadingMyEquipments)
        .subscribe((loadingMyEquipments) => {
          this.loadingMyEquipments = loadingMyEquipments;
        }),
    );
  }

  viewAssignedDocument(equipment: AssignedEquipmentModel) {
    this.store.dispatch(getEquipmentAssignPdf({
      assignedEquipmentID: equipment.id,
      returned: false,
      download: true
    }));
  }

  viewReturnedDocument(equipment: AssignedEquipmentModel) {
    this.store.dispatch(getEquipmentAssignPdf({
      assignedEquipmentID: equipment.id,
      returned: true,
      download: true
    }));
  }

  signAssignement(equipment: AssignedEquipmentModel) {
    this.router.navigate(["/equipment/signAssign/" + equipment.id]);
  }

  isCampusAssignment(equipment: AssignedEquipmentModel): boolean {
    return !!equipment?.assignedProgramID && !equipment?.userID;
  }

  getAssignSignedDisplay(equipment: AssignedEquipmentModel): string {
    if (this.isCampusAssignment(equipment)) {
      return "Campus";
    }
    return equipment?.assignSigned ? "Yes" : "No";
  }
}
